<template>
  <div class="h-full flex" :gutter="10">
    <div class="h-full w-300px flex-shrink-0">
      <el-card class="h-full w-300px mr-10px" :body-style="{ height: '100%' }">
        <div class="flex items-center">
          <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">角色</span>
        </div>
        <div class="flex mt-10px mb-10px">
          <el-input
            v-model="treeFilter"
            placeholder="请输入"
            class="flex-1 mr-10px"
            clearable
            prefix-icon="el-icon-search"
          ></el-input>
          <el-button size="small" type="primary" @click="treeSearch">搜索</el-button>
        </div>
        <el-tree
          :data="treeData"
          :props="treeProps"
          highlight-current
          node-key="id"
          :filter-node-method="filterTree"
          @node-click="handleNodeClick"
          v-loading="treeLoading"
          ref="tree"
          class="overflow-y-auto"
        >
          <el-tooltip effect="dark" :content="node.label" placement="top" slot-scope="{ node }">
            <div class="w-full truncate">{{ node.label }}</div>
          </el-tooltip>
        </el-tree>
      </el-card>
    </div>
    <div class="h-full rightCol flex-auto ml-10px w-0px">
      <el-card class="h-full flex-1" v-loading="tableLoading" :body-style="{ height: '100%' }">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="栏目" name="0" class="h-full"> </el-tab-pane>
          <el-tab-pane label="组件" name="1" class="h-full"> </el-tab-pane>
        </el-tabs>
        <el-table
          v-if="activeName === '0'"
          height="calc(100% - 100px)"
          stripe
          :data="tableData"
          border
          row-key="id"
          :tree-props="{ children: 'child' }"
        >
          <el-table-column label="栏目名称" prop="name" width="500px">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.hasChoose"
                :disabled="!isEdit"
                @change="CheckedChange($event, scope.row, 'column')"
                >{{ scope.row.name }}</el-checkbox
              >
            </template>
          </el-table-column>
          <el-table-column label="权限">
            <template slot-scope="scope">
              <el-checkbox-group
                v-model="scope.row.columnRights"
                :disabled="!isEdit"
                @change="superChange(scope.row, 'column')"
              >
                <el-checkbox label="add">新增</el-checkbox>
                <el-checkbox label="delete">删除</el-checkbox>
                <el-checkbox label="edit">编辑</el-checkbox>
                <el-checkbox label="import">导入</el-checkbox>
                <el-checkbox label="export">导出</el-checkbox>
                <el-checkbox label="show">显示</el-checkbox>
                <el-checkbox label="top">置顶</el-checkbox>
                <el-checkbox label="read">查看栏目</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          height="calc(100% - 100px)"
          v-if="activeName === '1'"
          stripe
          :data="tableDataComponents"
          border
          row-key="id"
          :tree-props="{ children: 'child' }"
        >
          <el-table-column label="组件名称" prop="name" width="500px">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.hasChoose"
                :disabled="!isEdit"
                @change="CheckedChange($event, scope.row, 'component')"
                >{{ scope.row.name }}</el-checkbox
              >
            </template>
          </el-table-column>
          <el-table-column label="权限">
            <template slot-scope="scope">
              <el-checkbox-group
                v-model="scope.row.columnRights"
                :disabled="!isEdit"
                @change="superChange(scope.row, 'component')"
              >
                <el-checkbox label="add">新增</el-checkbox>
                <el-checkbox label="delete">删除</el-checkbox>
                <el-checkbox label="edit">编辑</el-checkbox>
                <el-checkbox label="import">导入</el-checkbox>
                <el-checkbox label="export">导出</el-checkbox>
                <el-checkbox label="show">显示</el-checkbox>
                <el-checkbox label="read">查看组件</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="text-right mt-20px">
          <el-button size="small" type="primary" @click="isEdit = true" v-if="!isEdit"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="primary"
            v-else
            @click="savePermiss"
            >保存</el-button
          >
          <el-button size="small" v-if="isEdit" @click="cancel">取消</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script type="text/babel">
import { treeToOneArray } from '@/assets/js/Common'
import { ColumApi, ColumnRightsApi } from '@wiz-api/workbench'
import { RoleApi } from '@wiz-api/abp-identity'

const dataApi = new ColumApi()
const columnRightsApi = new ColumnRightsApi()

// settings.json配置地址："abp-identity": "dev01",  http://devaspnetcore01.wiz.top:7990
const roleApi = new RoleApi()

export default {
  data() {
    return {
      tableLoading: false,
      keyWord: '',
      treeFilter: '',
      treeData: [],
      treeProps: {
        label: 'name',
      },
      treeLoading: false,
      tableData: [],
      tableDataComponents: [],
      currentTreeSelect: null,
      isEdit: false,
      roleId: '',
      activeName: '0',
      columnPermissions: ['add', 'delete', 'export', 'import', 'edit', 'show', 'top', 'read'],
      componentPermissions: ['add', 'delete', 'export', 'import', 'edit', 'show', 'read'],
      templeteArr: [],
    }
  },
  async created() {
    this.getRoleList()
  },
  methods: {
    formaterColumnRights(data) {
      if (!data) {
        return []
      }
      return JSON.parse(data)
    },
    treeSearch() {
      this.$refs.tree.filter(this.treeFilter)
      this.$nextTick(() => {
        const firstFilterNode = _.find(this.treeData, (item) => {
          return item.name.indexOf(this.treeFilter) > -1
        })
        if (firstFilterNode) {
          this.$refs.tree.setCurrentKey(firstFilterNode.id)
          this.handleNodeClick(firstFilterNode)
        }
      })
    },
    async getRoleList() {
      this.treeLoading = true
      const [err, res] = await roleApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.treeData = res.items
        if (this.treeData.length) {
          this.$nextTick(() => {
            const data = this.treeData[0]
            this.$refs.tree.setCurrentKey(data.id)
            this.handleNodeClick(data)
          })
        }
      }
      this.treeLoading = false
    },
    handleNodeClick(data) {
      this.roleId = data.id
      this.getColumList()
      this.getComponents()
    },
    filterTree(value, data) {
      return data.name.includes(value)
    },
    async getColumList() {
      this.tableData = []
      const [err, res] = await dataApi.tree(0, { roleId: this.roleId })
      if (!err && res) {
        this.tableData = res
        this.tableData.forEach((v) => {
          this.columnRightsArr(v, 'column')
        })
        this.templeteArr = treeToOneArray(this.tableData, 'child')
      }
    },
    async getComponents() {
      this.tableDataComponents = []
      const [err, res] = await dataApi.tree(1, { roleId: this.roleId })
      if (!err && res) {
        this.tableDataComponents = res
        this.tableDataComponents.forEach((v) => {
          this.columnRightsArr(v, 'component')
        })
      }
    },
    CheckedChange(check, data, type) {
      const permissions = type === 'column' ? this.columnPermissions : this.componentPermissions
      if (check) {
        this.underCheck(data, permissions, check)
      } else {
        this.underCheck(data, [], check)
      }
    },
    underCheck(data, value, check) {
      data.columnRights = value
      if (data.child) {
        data.child.forEach((v) => {
          this.$set(v, 'hasChoose', check) // 添加
          this.underCheck(v, value)
        })
      }
    },
    superChange(data, type) {
      const status = this.formaterChoose(data.columnRights, type)
      data.hasChoose = status

      const checkItme = _.find(this.templeteArr, (item) => {
        return item.id === data.id
      })
      const isCheck = data.columnRights.length > checkItme.columnRights.length
      const addcheck = isCheck
        ? _.difference(data.columnRights, checkItme.columnRights)
        : _.difference(checkItme.columnRights, data.columnRights)

      if (data.child) {
        _.map(data.child, (item) => {
          item.columnRights = isCheck
            ? [...addcheck, ...item.columnRights]
            : _.difference(item.columnRights, addcheck)
          item.hasChoose = status
        })
      }
      if (data.parentId) {
        this.filterParent(data, this.tableData, status, addcheck, isCheck)
      }
      this.templeteArr = treeToOneArray(this.tableData, 'child')
    },
    filterParent(data, arr, status, addcheck, isCheck) {
      for (let i = 0; i < arr.length; i += 1) {
        if (data.parentId === arr[i].id) {
          arr[i].columnRights = isCheck
            ? [...addcheck, ...item.columnRights]
            : _.difference(arr[i].columnRights, addcheck)
          arr[i].hasChoose = status
          return
        }
        if (arr[i].child) {
          this.filterParent(data, arr[i].child, status, addcheck, isCheck)
        }
      }
    },
    formaterChoose(data, type) {
      const permissions = type === 'column' ? this.columnPermissions : this.componentPermissions
      // 判断选中
      if (_.difference(permissions, data).length === permissions.length) {
        return false
      }
      return true // 相同
    },
    // 定义全部初始数据
    columnRightsArr(v, type) {
      v.columnRights = this.formaterColumnRights(v.columnRights)
      this.$set(v, 'hasChoose', this.formaterChoose(v.columnRights, type)) // 添加
      if (v.child && v.child.length) {
        v.child.forEach((value) => {
          this.columnRightsArr(value, type)
        })
      }
    },
    // 保存
    async savePermiss() {
      const markArr = []
      this.updataArr(this.tableData, markArr)
      const data = markArr.map((v) => {
        return {
          columnId: v.id,
          roleId: this.roleId,
          rights: JSON.stringify(v.columnRights),
        }
      })
      const [err, res] = await columnRightsApi.update({ body: data })
      const dataComopnent = this.tableDataComponents.map((v) => {
        return {
          columnId: v.id,
          roleId: this.roleId,
          rights: JSON.stringify(v.columnRights),
        }
      })
      const [errComopnent, resComopnent] = await columnRightsApi.update({ body: dataComopnent })
      if (!err && !errComopnent && res && resComopnent) {
        this.$message.success('保存成功')
        this.getColumList()
        this.getComponents()
        this.isEdit = false
      }
    },
    // 递归平级数据
    updataArr(data, markArr) {
      data.forEach((v) => {
        markArr.push(v)
        if (v.child && v.child.length) {
          this.updataArr(v.child, markArr)
        }
      })
    },
    cancel() {
      this.isEdit = false
      this.getColumList()
    },
    handleClick(tab, event) {},
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
